import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { toSignal } from '@angular/core/rxjs-interop';
import { map, shareReplay } from 'rxjs';
import { OwnerService } from '../../../common/owner.service';
import { OwnerLocation } from '../../types/registration-types';
import { SmsRegistrationFormV2Component } from '../../a2p-registration/sms-registration-form-v2/sms-registration-form-v2.component';
import { RegulationService } from '../regulation.service';
import { SmsRegulatoryStatusComponent } from '../status/sms-regulatory-status.component';
import { Country, countryFromCode } from '../../../constants';
import { SmsAustraliaFormComponent } from './australia/sms-australia-form.component';
import { SmsItalyFormComponent } from './italy/sms-italy-form.component';
import { SmsSouthAfricaFormComponent } from './south-africa/sms-south-africa-form.component';

export const BUSINESS_NAME_FOR_PROCESSING_ADDRESS = 'process_address_business_name';
export const STREET_ADDRESS_FOR_PROCESSING_ADDRESS = 'process_address_street';
export const STREET_ADDRESS_SECONDARY_FOR_PROCESSING_ADDRESS = 'process_address_street_secondary';
export const CITY_FOR_PROCESSING_ADDRESS = 'process_address_city';
export const STATE_FOR_PROCESSING_ADDRESS = 'process_address_region';
export const POSTAL_CODE_FOR_PROCESSING_ADDRESS = 'process_address_postal_code';
export const COUNTRY_FOR_PROCESSING_ADDRESS = 'process_address_iso_country';

@Component({
  selector: 'sms-regulatory-form',
  imports: [
    SmsSouthAfricaFormComponent,
    SmsItalyFormComponent,
    SmsAustraliaFormComponent,
    SmsRegistrationFormV2Component,
    SmsRegulatoryStatusComponent,
  ],
  templateUrl: './sms-regulatory-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sms-regulatory-form.component.scss',
})
export class SmsRegulatoryFormComponent {
  private readonly ownerService = inject(OwnerService);
  private readonly regulationService = inject(RegulationService);
  protected readonly countries = Country;

  protected readonly $country = toSignal(
    this.ownerService.getOwnerLocation$().pipe(
      map((location: OwnerLocation): Country | undefined => countryFromCode(location.country)),
      shareReplay({ bufferSize: 1, refCount: true }),
    ),
    { initialValue: undefined as Country | undefined },
  );

  protected readonly $hasSubmission = toSignal(this.regulationService.hasSubmission$, { initialValue: false });
}
